import { useState } from "react";
import ModalComponent from "..";
import { SinglePayoutAccount } from "../../../redux/features/payment/payment.types";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { InfoCard } from "../../cards/infoCard";
import { PayoutForm } from "../../payout";

export const AddPayoutAccountModal = ({
  open,
  handleClose,
  onSuccess = () => {},
  mode = "create",
  account,
}: ModalCompProps & {
  onSuccess: () => void;
  mode?: "create" | "edit";
  account?: SinglePayoutAccount;
}) => {
  const [showModalHeader, setShowModalHeader] = useState<boolean>(true);

  const close = () => {
    handleClose();
  };

  return (
    <ModalComponent
      open={open}
      handleClose={close}
      className="!p-"
      dialogClassName=""
      closeOnOverlayClick
      showHeader={showModalHeader}
      title={`${mode === "create" ? "Add" : "Update"} Bank Details`}
      subtitle={""}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <div className="flex flex-col gap-4">
        {showModalHeader ? (
          <InfoCard
            leftIcon="info"
            title="You can only add one payout account at a time"
            text="Your payout account should be the same name as your profile name"
            className="md:!items-start"
          />
        ) : undefined}

        <PayoutForm
          onSuccess={({ resetForm }) => {
            resetForm();
            onSuccess();
          }}
          mode={mode}
          type={account?.currency}
          account={account}
          onStepChange={(step) => {
            if (step > 1) {
              setShowModalHeader(false);
            } else {
              setShowModalHeader(true);
            }
          }}
          isModalDisplay={true}
        >
          {({ handleSubmit, loading, disabled }) => {
            return (
              <div className="col-span-full grid w-full grid-cols-2 items-center justify-end gap-2 md:flex">
                <Button
                  text="Cancel"
                  type="button"
                  onClick={() => {
                    close();
                  }}
                  variation="plain-grey"
                  className="md:max-w-fit"
                />

                <Button
                  text={"Save"}
                  type="button"
                  onClick={handleSubmit}
                  className="md:max-w-fit"
                  loading={loading}
                  disabled={disabled}
                />
              </div>
            );
          }}
        </PayoutForm>
      </div>
    </ModalComponent>
  );
};
